import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Container, FileUpload, Grid, Input, Modal, SpaceBetween, StatusIndicator, Tabs, Link, Alert, ButtonDropdown, FormField } from "@amzn/awsui-components-react";
import firstpassLogo from '../../../images/firstpassLogo.png'
import aiInsights from '../../../images/aiInsights.svg'
import '../styles.scss'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Storage } from 'aws-amplify';
import { AgGridReact } from 'ag-grid-react';
import { useHistory, useLocation } from "react-router-dom";
import { firstPassRunNoteValidator, getFirstPassHistoryItem, listFirstPassEntities } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus";
import { convertToLocalTime } from "src/Ateam-BI/CorpReporting/Utility";
import FirstPassResultComponent from "./FirstPassResultComponent";
import { configureFSS3 } from "src/context/AuthContextUtility";
import { v4 as uuidv4 } from 'uuid';
import FirstPassPollAndPullResults from "./FirstPassPollAndPullResults";
import { loadResultsFromS3, parseStatusReportCounts } from "../Utility";
import { getFSS3Config } from "src/utilities/AWSServices";
import FirstPassAccessDeniedComponent from "./FirstPassAccessDeniedComponent";
import {  uploadDocumentToVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';
import { createPreference, deletePreference, listPreference } from "src/utilities/AppSyncPlusAPIs";
import { deepEqual } from "src/Ateam-BI/utils/generalUtils";
import { downloadFirstPassResults } from "../pdfUtils";

const FirstPassEntityListComponent = (props) => {
  const gridRef = useRef();
  const tabsRef = useRef();
  const userId = useSelector((globalState) => globalState.auth.userId)
  const isPortalAdmin = useSelector((globalState)=>globalState.auth.isPortalAdmin)
  const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)
  const isFirstPassProFullUser = useSelector((globalState)=>globalState.auth.isFirstPassProFullUser)
  const [entityList, setEntityList] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState(null)
  const [resultsPerRequestId, setResultsPerRequestId] = useState({})
  const [exceptionCountsPerRequestId, setExceptionCountsPerRequestId] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [resultTabs, setResultTabs] = useState([])
  const [showRunNoteValidatorModal, setShowRunNoteValidatorModal] = useState(false)
  const [noteValidatorModalLoaderMessage, setNoteValidatorModalLoaderMessage] = useState(null)
  const [validatorFiles, setValidatorFiles] = React.useState([]);
  const [validatorRequestId, setValidatorRequestId] = useState(null)
  
  const [savedFilters, setSavedFilters] = useState({})
  const [haveFiltersChanged, setHaveFiltersChanged] = useState(false)
  const [pendingFilterModel, setPendingFilterModel] = useState(null)
  const [dataRendered, setDataRendered] = useState(false)
  const [isFirstDataProcessed, setIsFirstDataProcessed] = useState(false)

  const FIRSTPASS_FILTER_PREFERENCE_TYPE = `FIRSTPASS_FILTER`
  const FIRSTPASS_ASSOCIATION_ID = `FIRSTPASS_FILTER_ALIAS#${userId}`
  const FIRSTPASS_ASSOCIATION_TYPE = 'FIRSTPASS_FILTER_ALIAS'

  const history = useHistory()
  const location = useLocation()
  const defaultColDef = {
    filter: 'agSetColumnFilter',
    filterParams: {
      buttons: ['reset', 'apply'],
      debounceMs: 200
    }
  };
  const columnDefs = useMemo(() => [
    { field: 'accounting_team', headerName: 'Team', width: '140px', resizable: true, sortable: true, checkboxSelection: true, headerCheckboxSelection: true },
    { field: 'entity_code', headerName: 'Company Code', width: '160px', sortable: true, resizable: true },
    { field: 'entity_name', headerName: 'Entity Name', width: '250px', sortable: true, sortable: true, resizable: true },
    { field: 'language', headerName: 'Language', width: '130px', sortable: true, sortable: true, resizable: true },
    { field: 'latest_status', headerName: 'Latest Status', width: '150px', sortable: true, resizable: true, cellRenderer: (params) => {return params.value || ''}, valueGetter: (params) => {
        return resultsPerRequestId?.[params?.data?.request_id]?.execution_status || '';
    } },
    { field: 'important_count', headerName: '⚠️ Important', width: '130px', sortable: true, resizable: true, cellRenderer: (params) => {
      const requestId = params?.data?.request_id;
      const counts = exceptionCountsPerRequestId?.[requestId];
      if (counts === undefined) {
        return resultsPerRequestId?.[requestId]?.execution_status === 'success' ? <StatusIndicator type="loading"></StatusIndicator> : '-';
      }
      if (counts === null) return '-';
      return <span style={{ color: '#d13212', fontWeight: 'bold' }}>{counts.important}</span>;
    }, valueGetter: (params) => {
      const counts = exceptionCountsPerRequestId?.[params?.data?.request_id];
      return counts ? counts.important : '';
    } },
    { field: 'fyi_count', headerName: 'ℹ️ Informational', width: '150px', sortable: true, resizable: true, cellRenderer: (params) => {
      const requestId = params?.data?.request_id;
      const counts = exceptionCountsPerRequestId?.[requestId];
      if (counts === undefined) {
        return resultsPerRequestId?.[requestId]?.execution_status === 'success' ? <StatusIndicator type="loading"></StatusIndicator> : '-';
      }
      if (counts === null) return '-';
      return <span style={{ color: '#0972d3' }}>{counts.fyi}</span>;
    }, valueGetter: (params) => {
      const counts = exceptionCountsPerRequestId?.[params?.data?.request_id];
      return counts ? counts.fyi : '';
    } },
    { field: 'pdf_updated_time', headerName: 'PDFs Last Updated', width: '250px', sortable: true, resizable: true, cellRenderer: (params) => { return params.value ? <Box>{params.value}</Box> : ''; }, valueGetter: (params) => { return params?.data?.pdf_updated_time ? convertToLocalTime(params.data.pdf_updated_time, true): '' } },
    { field: 'last_updated', headerName: 'Execution Completion', width: '250px', sortable: true, resizable: true, cellRenderer: (params) => { return params.value ? <Box>{params.value}</Box> : ''; }, valueGetter: (params) => { return resultsPerRequestId?.[params?.data?.request_id] ? convertToLocalTime(resultsPerRequestId?.[params?.data?.request_id].created_at, true) : (params?.data?.last_updated ? convertToLocalTime(params.data.last_updated, true) : '') } },
  ], [resultsPerRequestId, exceptionCountsPerRequestId]);


  useEffect(() => {
    if (isFirstDataProcessed) {
      const searchParams = new URLSearchParams(location.search);
      const resultIds = searchParams.getAll('resultId');
      if (resultIds.length > 0 && gridRef?.current?.api && resultTabs.length === 0) {
        gridRef.current.api.forEachNode((node) => {
          if (resultIds.includes(node.data.request_id)) {
            node.setSelected(true);
          }
        });
        const selectedRows = gridRef?.current?.api?.getSelectedRows();
        viewResults(selectedRows);
      }
    }

  }, [isFirstDataProcessed]);

  useEffect(() => {
    loadView()
  }, []);

  useEffect(() => {
  if (userId) {
    loadSavedFilters();
  }
}, [userId]);

  useEffect(() => {
    if (dataRendered && pendingFilterModel) {
        gridRef.current.api.setFilterModel(pendingFilterModel);
        setPendingFilterModel(null);
    }
  }, [dataRendered, pendingFilterModel]);


  useEffect(() => {
    if (!showRunNoteValidatorModal) {
      resetValidatorModalContents()
    }
  }, [showRunNoteValidatorModal]);

  useEffect(() => {
    if (validatorRequestId) {
      addTabForPollAndPullResults(selectedRows[0], validatorRequestId)
    } else {
      clearFromTabs(validatorRequestId)
    }
  }, [validatorRequestId]);

  useEffect(() => {
    onFilterTextBoxChanged()
    return () => {
    };
  }, [quickFilterText]);

  function onFilterTextBoxChanged() {
    gridRef?.current?.api?.setGridOption(
      "quickFilterText",
      quickFilterText,
    );
  }

  const loadSavedFilters = () => {
    if (!userId) return;
    
    listPreference(
      FIRSTPASS_ASSOCIATION_ID,
      FIRSTPASS_ASSOCIATION_TYPE,
      FIRSTPASS_FILTER_PREFERENCE_TYPE,
      function onSuccess(response) {
        const userFilter = response?.data?.listPreference?.items?.[0];
        if (userFilter) {
          setSavedFilters(userFilter);
          setHaveFiltersChanged(false);
          const filterModel = JSON.parse(userFilter.information);
          setPendingFilterModel(filterModel);
        }
      },
      function onFailure(error) {
        console.error('Error loading saved filters:', error);
      }
    );
  };

  const saveCurrentFilters = async () => {
    if (!gridRef?.current?.api) return;
    const previouslySavedFilters = savedFilters;
    
    const currentFilterModel = gridRef.current.api.getFilterModel();
    
    await new Promise((resolve, reject) => {
      const newPreferenceId = uuidv4();
      createPreference(
        newPreferenceId,
        FIRSTPASS_FILTER_PREFERENCE_TYPE,
        `${userId}'s FirstPass Filters`,
        FIRSTPASS_ASSOCIATION_ID,
        FIRSTPASS_ASSOCIATION_TYPE,
        userId,
        currentFilterModel,
        null,
        function onSuccess(response) {
          const newFilter = {
            preferenceId: newPreferenceId,
            preferenceType: FIRSTPASS_FILTER_PREFERENCE_TYPE,
            label: `${userId}'s FirstPass Filters`,
            information: JSON.stringify(currentFilterModel),
          };
          setSavedFilters(newFilter);
          setHaveFiltersChanged(false);
          resolve();
        },
        function onFailure(error) {
          console.error('Error saving filters:', error);
          resolve();
        }
      );
    })

    if (previouslySavedFilters?.preferenceId) {
      await new Promise((resolve, reject) => {
        deletePreference(
          previouslySavedFilters.preferenceId,
          null,
          () => resolve(),
          (error) => {
            console.error('Error deleting old filter:', error);
            resolve();
          }
        );
      });
    }
  };

  const onFilterChanged = useCallback(() => {
    if (!gridRef?.current?.api) return;
    const filterModel = gridRef.current.api.getFilterModel();
    const savedFiltersModel = savedFilters?.information ? JSON.parse(savedFilters?.information) : {}
    setHaveFiltersChanged(!deepEqual(savedFiltersModel, filterModel));
  }, [savedFilters]);
  
  const downloadResults = async (data) => {
    await downloadFirstPassResults(
      data,
      () => setDownloadLoader(prev => ({ ...prev, [data.request_id]: true })),
      () => setDownloadLoader(prev => ({ ...prev, [data.request_id]: false })),
      'rich'
    );
  }

  const clearFromTabs = (requestId) => {
    let tabs = resultTabs.filter(tab => tab.id !== requestId);
    setResultTabs(tabs)
  }

  const addTabForPollAndPullResults = (data, requestId) => {
    let tab = {
      label: `Note validator - ${data.entity_name}` || 'Note validator result',
      id: requestId,
      content: pollAndPullView(requestId, data)
    }
    let tabs = resultTabs.filter(tab => tab.id !== requestId);
    setResultTabs([tab, ...tabs]);
  }

  const resetValidatorModalContents = () => {
    setValidatorFiles([])
    setNoteValidatorModalLoaderMessage(null)
  }

  const loadView = () => {
    fetchAllEntities();
  }

  const loadRequestInformation = (request_id) => {
    if (!request_id) {
      return Promise.resolve()
    }
    if (!resultsPerRequestId.hasOwnProperty(request_id)) {
      return new Promise((resolve) => {
        getFirstPassHistoryItem(request_id, async function onSuccess(response) {
          const historyItem = response?.data?.getFirstPassHistoryItem;
          setResultsPerRequestId(prev => ({ ...prev, [request_id]: historyItem }));
          
          if (historyItem?.execution_status === 'success' && historyItem?.response_s3_path) {
            try {
              const jsonData = await loadResultsFromS3(historyItem);
              const counts = parseStatusReportCounts(jsonData);
              setExceptionCountsPerRequestId(prev => ({ ...prev, [request_id]: counts }));
            } catch (error) {
              setExceptionCountsPerRequestId(prev => ({ ...prev, [request_id]: null }));
            }
          }
          resolve();
        }, function onFailure(error) {
          // console.error('Error fetching entities:', error);
          resolve();
        })
      });
    }

    return Promise.resolve()
  }

  const fetchAllEntities = (nextToken = null, accumulatedItems = []) => {
    setIsLoading(true);

    listFirstPassEntities(
      2000,
      nextToken,
      function onSuccess(response) {
        const items = response?.data?.listFirstPassEntities?.items || [];
        const newAccumulatedItems = [...accumulatedItems, ...items];
        const newNextToken = response?.data?.listFirstPassEntities?.nextToken;

        // If there's a nextToken, fetch more
        if (newNextToken) {
          fetchAllEntities(newNextToken, newAccumulatedItems);
          const sortedItems = newAccumulatedItems.sort(
            (a, b) => new Date(b.last_updated) - new Date(a.last_updated)
          );
          setEntityList(sortedItems);
          setIsLoading(false);
        } else {
          // No more data, sort and set final list
          const sortedItems = newAccumulatedItems.sort(
            (a, b) => new Date(b.last_updated) - new Date(a.last_updated)
          );
          setEntityList(sortedItems);
          setIsLoading(false);
        }
      },
      function onFailure(error) {
        // console.error('Error fetching entities:', error);
        setIsLoading(false);
      }
    );
  };

  const onFirstDataRendered = useCallback(async (params) => {
    setDataRendered(true)
    const promises = [];
    params.api.forEachNode((rowNode) => {
      promises.push(loadRequestInformation(rowNode?.data?.request_id));
    });
    await Promise.all(promises);
    setIsFirstDataProcessed(true);
  }, []);

  const onSelectionChanged = () => {
    const selectedRows = gridRef?.current?.api?.getSelectedRows();
    setSelectedRows(selectedRows)
  };

  const clearResultsSection = () => {
    setResultTabs([])
    updateUrlWithResultIds([])
  }

  const updateUrlWithResultIds = (requestIds) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('resultId');
    requestIds.forEach(id => searchParams.append('resultId', id));
    history.replace({ pathname: location.pathname, search: searchParams.toString() });
  }

  const viewResults = (selectedRows) => {
    let tabs = []
    let requestIds = []
    for (let selectedRow of selectedRows) {
      let request_id = selectedRow?.request_id
      if (request_id && resultsPerRequestId?.hasOwnProperty(request_id)) {
        requestIds.push(request_id)
        tabs.push({
          label: selectedRow.entity_name || 'Result',
          id: request_id,
          dismissible: true,
          dismissLabel: "Dismiss",
          onDismiss: (event) => {
            setResultTabs(prevTabs => {
              const newTabs = prevTabs.filter(tab => tab.id !== request_id);
              updateUrlWithResultIds(newTabs.map(t => t.id));
              return newTabs;
            });
          },
          content: <FirstPassResultComponent data={resultsPerRequestId[request_id]}>
          </FirstPassResultComponent>
        })
      }

    }
    setResultTabs(tabs)
    updateUrlWithResultIds(requestIds)
    setTimeout(() => {
      tabsRef.current?.scrollIntoView({ behavior: 'smooth',  block: 'start'  });
    }, 100);
  }

  const runValidatorFiles = async () => {
    // upload to S3
    setValidatorRequestId(null)
    configureFSS3()
    let uuid = uuidv4()
    let path = `validator/input/${uuid}/`
    setNoteValidatorModalLoaderMessage("Uploading..")
    const fnArray = validatorFiles[0].name.split('.')
    const contentType = fnArray[fnArray.length - 1]
    try {
          const result = await uploadDocumentToVault(contentType, VAULT_SERVICES.FIRST_PASS_UI_UPLOADS, {"file_path": `${path}${validatorFiles[0].name}`, "tagging": `userId=${userId}`}, validatorFiles[0])
          let row = selectedRows[0]
          firstPassRunNoteValidator(uuid, row.request_id, row.entity_code, row.language, getFSS3Config().S3.uploads_bucket, `${result.objectKey}`, function onSuccess(response) {
            setValidatorRequestId(JSON.parse(response.data.firstPassRunNoteValidator)?.requestId)
            setShowRunNoteValidatorModal(false)
          }, function onFailure(response) {
            setNoteValidatorModalLoaderMessage(null)
          })
    } catch(err) {
      console.error(err)
    }
    // Storage.vault.put(validatorFiles[0].name, validatorFiles[0], {
    //     level: "public",
    //     customPrefix: { public: path },
    //   })
    //     .then((result) => {
          
    //     })
    //     .catch(err => setAnnotationError("Saving failed"));
    

  }

  const pollAndPullView = (requestId, data) => {
    return <FirstPassPollAndPullResults requestId={requestId} data={data}></FirstPassPollAndPullResults>
  }

  return (

    <Box margin="l">
      <SpaceBetween direction="vertical">
        <Grid
          gridDefinition={[
            { colspan: { default: 3, xxs: 3 } },
            { colspan: { default: 9, xxs: 9 } }
          ]}
        >
          <div className="grid-column-wrapper">
          <Container>
              <SpaceBetween direction="vertical" size="l">
              <div className="left-container"> <img className="icon" src={firstpassLogo}></img></div>
              <Box variant="h3">Hello, {userId}! I am your friendly AI financial statement reviewer. I catch potential issues before Reviewer1(R1) review</Box>
              <Box variant="h3">The source of the Financial statements is the <Link external href="https://app.wdesk.com/a/QWNjb3VudB8xMDk3MDYzMTkyNw/files/folder/V0ZEYXRhRW50aXR5HkZvbGRlcjozODE4RjlDRDM4OEY1NjEzODY2NDU5OEMxQzVCMkY3Nw" variant="primary"> Workiva</Link> bulk export to S3. Results will be available within 2-3 mins from triggering the bulk export.</Box>
              <Box>
                <Box variant="h3">Let's get started:
                  <ol>
                    <li>Select one or multiple entities</li>
                    <li>Click view results</li>
                    <li>
                      or, Click 'Run Note Validator'</li>
                  </ol>
                </Box>
                <Box variant="h3">Note : 'Run Note Validator' will be enabled only if one entity is selected</Box>
                <br />
                <Box variant="h3">
                  View past reviews in <Link external variant="primary" href="/firstpass/history">History</Link>
                </Box>
              </Box>
              {/* <Box variant="h3"> 
                <Link
                onFollow={() =>
                  alert("You clicked the button link!")
                }
              >
                Learn more about my capabilities
              </Link>
              </Box> */}
            </SpaceBetween>
          </Container>
          </div>
          {/* Right Column */}
          {
            isPortalAdmin || isSupportAdmin || isFirstPassProFullUser ? 
            <div className="grid-column-wrapper">
            <div className="right-column-content">
              <div className="search-buttons-row">
                <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                  <Input
                    onChange={({ detail }) => setQuickFilterText(detail.value)}
                    value={quickFilterText}
                    expandToViewport={true}
                    placeholder='Type to search'
                  />
                  <Box float="right">
                    <SpaceBetween direction="horizontal" size="s">
                      {selectedRows?.length <= 0 && resultTabs?.length > 0 && (
                        <Button onClick={() => clearResultsSection(selectedRows)} variant="primary">Clear results</Button>
                      )}
                      <Button variant="link"
                        onClick={() => {
                          if (!haveFiltersChanged) {
                            gridRef?.current?.api?.setFilterModel(null);
                          }
                          saveCurrentFilters();
                        }}
                      >
                        {haveFiltersChanged ? 'Save filters' : 'Clear filters'}
                      </Button>
                      <Button onClick={() => viewResults(selectedRows)} disabled={!selectedRows || selectedRows?.length <= 0} variant="primary">View results</Button>
                      <Button onClick={() => setShowRunNoteValidatorModal(true)} disabled={selectedRows?.length != 1 || (selectedRows?.length == 1 && selectedRows[0]?.request_id == null)}>Run Note Validator</Button>

                      <Button onClick={() => history.push('/firstpass/history')}>History</Button>
                    </SpaceBetween>
                  </Box>
                </Grid>
              </div>
              <div className="ag-grid-wrapper">
                <div className="ag-theme-alpine">
                  <AgGridReact
                    ref={gridRef}
                    rowData={entityList}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}
                    enableRangeSelection={true}
                    rowSelection="multiple"
                    suppressRowClickSelection={true}
                    onSelectionChanged={onSelectionChanged}
                    animateRows={true}
                    pagination={true}
                    paginationPageSize={10}
                    paginationPageSizeSelector={[10, 50, 100]}
                    loading={isLoading}
                    onFirstDataRendered={onFirstDataRendered}
                    onFilterChanged={onFilterChanged}
                  />
                </div>
              </div>
            </div>
          </div> : <FirstPassAccessDeniedComponent></FirstPassAccessDeniedComponent>
          }
          
        </Grid>
          
        {
          resultTabs?.length > 0 && <div ref={tabsRef}>
            <hr></hr>
            <SpaceBetween direction="vertical" size="m">
              <SpaceBetween direction="vertical" size="xxs">
                <Box variant="h3" ><img
                  className="ai-button"
                  src={aiInsights}
                  alt=""
                /> Results Generated by AI</Box>
                <Box> <i>AI has limitations and may produce omissions or errors. Please review all important information. Known First Pass PRO limitations are documented on <Link external href="https://w.amazon.com/bin/view/Statcloseprocess/FSQA/FirstPass/"> this Wiki page</Link></i></Box>
              </SpaceBetween>
              <Tabs
                tabs={resultTabs}
              />
            </SpaceBetween>
          </div>
        }
        <Modal
          size="large"
          onDismiss={() => setShowRunNoteValidatorModal(false)}
          visible={showRunNoteValidatorModal}
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button onClick={() => {
                  setShowRunNoteValidatorModal(false)
                }} variant="link">Cancel</Button>
                <Button variant="primary" onClick={() => { runValidatorFiles() }} disabled={noteValidatorModalLoaderMessage}>Run</Button>
              </SpaceBetween>
            </Box>
          }
          header="Run note validator"
        >
          <SpaceBetween direction="vertical" size="m">
            <Box variant="awsui-key-label">Selected Entity: {selectedRows?.[0]?.entity_name}</Box>
            <Box>This widget supplements existing sepcific checks (KMP, ARO, Tax etc.) by validating ALL OTHER notes against theor supporting documents:</Box>
            <ul>
              <li>List EVERY line item from the note (amounts, %, quantities, dates)</li>
              <li>Maps to supporting document values</li>
              <li>Shows current & prior year comparisons</li>
              <li>Calculates variances and flags issues (✅/⚠️/ℹ️)</li>
              <li>Handles movement schedules with mathematical checks</li>
              <li>Provides specific document references</li>
              <li>Lists all differences with required actions</li>

            </ul>

            {
              noteValidatorModalLoaderMessage && <StatusIndicator type="loading">
                {noteValidatorModalLoaderMessage}
              </StatusIndicator>
            }

            <FileUpload
              onChange={({ detail }) => setValidatorFiles(detail.value)}
              value={validatorFiles}
              i18nStrings={{
                uploadButtonText: e =>
                  e ? "Choose files" : "Choose file",
                dropzoneText: e =>
                  e
                    ? "Drop files to upload"
                    : "Drop file to upload",
                removeFileAriaLabel: e =>
                  `Remove file ${e + 1}`,
                limitShowFewer: "Show fewer files",
                limitShowMore: "Show more files",
                errorIconAriaLabel: "Error",
                warningIconAriaLabel: "Warning"
              }}
              multiple
              showFileLastModified
              showFileSize
              showFileThumbnail
              tokenLimit={3}
              constraintText="Hint text for file requirements"
            />
          </SpaceBetween>
        </Modal>
      </SpaceBetween>
    </Box>


  );
};

export default FirstPassEntityListComponent;
